export type LayoutConfig = {
  title: string;
  page: string;
  hideHeroBanner?: boolean;
};
